import { isValid, parseISO, format } from 'date-fns';
import type {
  PastAnnualRevenueEarnings,
  PastTimeSeriesForCalculations,
} from '../types';

export const getMostRecentReportedYear = (
  pastAnnualRevenueEarnings?: PastAnnualRevenueEarnings
) => {
  const mostRecentReportedYear =
    pastAnnualRevenueEarnings &&
    pastAnnualRevenueEarnings.mostRecentReportedDate &&
    isValid(parseISO(pastAnnualRevenueEarnings.mostRecentReportedDate))
      ? format(
          parseISO(pastAnnualRevenueEarnings.mostRecentReportedDate),
          'yyyy'
        )
      : new Date().getFullYear().toString();

  return mostRecentReportedYear;
};

export const isMostRecentReportedYearInYearlyTimeSeries = ({
  mostRecentReportedYear,
  pastTimeSeriesModel,
}: {
  mostRecentReportedYear: string;
  pastTimeSeriesModel?:
    | PastAnnualRevenueEarnings
    | PastTimeSeriesForCalculations;
}): boolean => {
  return !!(
    pastTimeSeriesModel &&
    pastTimeSeriesModel.yearlyTimeSeries &&
    mostRecentReportedYear in pastTimeSeriesModel.yearlyTimeSeries
  );
};

export const getPresentRevenue = (
  mostRecentReportedYear: string,
  revenue: number,
  pastAnnualRevenueEarnings?: PastAnnualRevenueEarnings
) => {
  const presentRevenue = isMostRecentReportedYearInYearlyTimeSeries({
    mostRecentReportedYear,
    pastTimeSeriesModel: pastAnnualRevenueEarnings,
  })
    ? Number(
        pastAnnualRevenueEarnings?.yearlyTimeSeries[mostRecentReportedYear]
          .revenue
      )
    : revenue; // the yearlyTimeSeries revenue does not require multiplying by reporting unit

  return presentRevenue;
};
